const borderRadiusMap = {
  none: {
    banner: 'none',
    cta: 'none',
    input: 'none',
    modal: 'none',
  },
  sm: {
    banner: 'xs',
    cta: 'xs',
    input: 'xs',
    modal: 'xs',
  },
  md: {
    banner: 'sm',
    cta: 'md',
    input: 'sm',
    modal: 'sm',
  },
  lg: {
    banner: 'lg',
    cta: 'lg',
    input: 'md',
    modal: 'lg',
  },
  xl: {
    banner: 'xl',
    cta: 'full',
    input: 'lg',
    modal: 'xl',
  },
} as const;

export { borderRadiusMap };
